<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <p> 总金额：{{order_sum}}</p>
          <el-button class="new-btn" @click="showSearchOrder(1)">
            <span>按客户</span>
          </el-button>
          <el-button class="new-btn" @click="showSearchOrder(2)">
            <span v-if="user_type == 5">按市场人员</span>
            <span v-if="user_type == 1">查看业绩</span>
          </el-button>
          <el-button class="new-btn" @click="showSearchOrder(3)" v-if="user_type == 5">
            <span>按实验室</span>
          </el-button>
          <el-button class="new-btn" @click="showSearchOrder(4)" v-if="user_type == 5">
            <span>平台订单</span>
          </el-button>
          <el-button class="send-btn" @click="orderExcel" >
            <span>生成Excel</span>
          </el-button>
        </div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          :row-class-name="rowClass"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="lab_order_id"
            label="订单号" width=80>
          </el-table-column>
          <el-table-column
            prop="company_name"
            label="公司名称">
          </el-table-column>
          <el-table-column
            prop="total"
            label="总价" width=80>
          </el-table-column>
          <el-table-column
            prop="create_date"
            label="订单时间" width=140>
          </el-table-column>
          <el-table-column
            prop="days"
            label="期限" width=50>
          </el-table-column>
          <el-table-column
            prop="amount"
            label="数量" width=50>
          </el-table-column>
          <el-table-column label="操作" width=210>
            <template slot-scope="scope">
              <el-button
                size="mini" class="detail-btn" @click="handleSeeDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <search-order :search_type="search_type" @cancelsearch="close" @gotorders="gotOrders" v-if="search_show"> </search-order>
  </div>
</template>

<script type='text/ecmascript-6'>
import base from 'common/js/base.js' 
import SearchOrder from "components/SearchOrder.vue"
import { getStore, setStore, removeStore } from 'common/js/mUtils.js'
export default {
  data () {
    return {
      empty: '请输入搜索条件',
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      search_name: '',
      search_type: 0,
      old_search_type: 0,
      search_id: 0,
      start_date: null,
      end_date: null,
      search_show: false,
      user_type: 0,
      order_sum: 0,
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
  },
  created () {
    this.user_type = getStore('user_type')
    let order_state_json = getStore('order-state')
    removeStore('order-state')
    if (order_state_json != null) {
      let order_state = JSON.parse(order_state_json)
      if (order_state.state == 4) {
        this.page = order_state.page_num
        this.search_id = order_state.search_id
        this.start_date = order_state.start_date
        this.end_date = order_state.end_date
        this.search_type = order_state.search_type
      }
    }
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    rowClass({row}){
      if (row.type == 1) {
        return 'row-color'
      }
    },
    openHtml(URL) {
      let  temp_form = document.createElement("form");
      temp_form.action = URL;
      temp_form.target = "_blank";
      temp_form.method = "post";
      temp_form.style.display = "none";
      let opt = document.createElement("input");
      opt.name="access_token";
      opt.value="证书参数"
      temp_form.appendChild(opt);
      document.body.appendChild(temp_form);
      temp_form.submit();
    },
    orderExcel() {
      let that = this
      if (that.tableData.length == 0) {
        that.$message({
          message: '订单统计结果为空。',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      that.$api.orderExcel({
        search_type: that.search_type,
        id: that.search_id,
        start_date: that.start_date,
        end_date: that.end_date,
        total: that.total,
        order_sum: that.order_sum
      }).then(res => {
        if (res.data.msg === false) {
          that.$message({
            message: res.data.error,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
          return
        }
        let uri = res.data.uri
        let url = `${base.office}report%2F${uri}`
        that.openHtml(url)
      }).catch(e => {
        that.$message({
          message: `${e}`,
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    initData() {
      this.searchOrder()
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      this.searchOrder()
    },
    showSearchOrder(search_type) {
      this.old_search_type = this.search_type
      this.search_type = search_type
      this.search_show = true
    },
    gotOrders(results) {
      this.search_show = false
      this.tableData = results.orderList
      this.search_id = results.selected_id
      this.start_date = results.start_date
      this.end_date = results.end_date
      this.order_sum = results.order_sum
      this.total = Number(results.total)
    },
    close () { // 监听自定义的
      this.search_show = false
      this.search_type = this.old_search_type
    },
    searchOrder() {
      let that = this
      if (this.search_id != 0) {
        this.$api.searchOrders({
          search_type: that.search_type,
          id: that.search_id,
          start_date: that.start_date,
          end_date: that.end_date,
          page_num: (that.page - 1)*that.limit
        }).then(res => {
          if (res.data.msg === false) {
            that.$message({
              message: res.data.error,
              type: 'error',
              customClass: 'msg-position',
              showClose: true
            })
            return
          }
          if (res.data.data.detail.length > 0) {
            that.tableData = res.data.data.detail
            that.order_sum = res.data.data.order_sum
            that.total = Number(res.data.data.total)
          } else {
            that.tableData = []
            that.order_sum = 0
            that.total = 0
            that.$message({
              message: '没有找到符合条件的订单。',
              type: 'error',
              customClass: 'msg-position',
              showClose: true
            })
          }
        }).catch(e => {
          that.$message({
            message: `${e}`,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        })
      } 
    },
    handleSeeDetail (row) { // 点击详情
      // save state, 0:已完成1:未完成2:历史3:统计
      setStore('order-state',{state:4, page_num:this.page, search_id:this.search_id, start_date:this.start_date, end_date:this.end_date, search_type: this.search_type})
      this.$router.push({
        path: '/orderDetail',
        query: { lab_order_id: row.lab_order_id, type: row.type, his_state: 'complete'}
      })
    }
  },
  components: {
    SearchOrder
  },
  watch: {
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/box.styl'
</style>
